import { createContext, useContext, type ReactNode } from 'react';

import type { GetAppSettingsQuery } from '#graphql/queries/app-settings';

export type AppSettingsContextValue = GetAppSettingsQuery['appSettings'];

const AppSettingsContext = createContext<AppSettingsContextValue | undefined>(
  undefined,
);

interface AppSettingsProviderProps {
  value: AppSettingsContextValue;
  children: ReactNode;
}

export function AppSettingsProvider({
  value,
  children,
}: AppSettingsProviderProps) {
  return (
    <AppSettingsContext.Provider value={value}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings(): AppSettingsContextValue {
  const value = useContext(AppSettingsContext);
  if (value === undefined) {
    throw new Error('useAppSettings must be used within AppSettingsProvider');
  }

  return value;
}
